import { styled } from '@mui/material/styles';
import { Box } from '@mui/system';

export const Wrapper = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '410px',

  '.MuiButton-contained': {
    marginTop: '40px',
  },

  [theme.breakpoints.down('sm')]: {
    maxWidth: 'unset',

    '.MuiTypography-h3': {
      marginBottom: '15px',
      textAlign: 'center',
    },

    '.MuiButton-contained': {
      marginTop: '32px',
    },
  },
}));
